import { render, staticRenderFns } from "./Essential-oils.vue?vue&type=template&id=70c04dca&"
import script from "./Essential-oils.vue?vue&type=script&lang=js&"
export * from "./Essential-oils.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports